import type { SVGProps } from 'react';

const SvgGuideMd = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 40 40' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <g clipPath='url(#clip0_18420_5655)'>
      <path
        d='M20.2 10.9992H7.80002C7.00002 10.9992 6.40002 10.3992 6.40002 9.59922C6.40002 8.79922 7.00002 8.19922 7.80002 8.19922H20.2C21 8.19922 21.6 8.79922 21.6 9.59922C21.6 10.3992 21 10.9992 20.2 10.9992Z'
        fill='currentColor'
      />
      <path
        d='M14.2 16.8H7.80002C7.00002 16.8 6.40002 16.2 6.40002 15.4C6.40002 14.6 7.00002 14 7.80002 14H14.2C15 14 15.6 14.6 15.6 15.4C15.6 16.2 15 16.8 14.2 16.8Z'
        fill='currentColor'
      />
      <path
        d='M29.6 16.3992V6.39922C29.6 3.59922 27.2 1.19922 24.4 1.19922H6.40001C3.60001 1.19922 1.20001 3.39922 1.20001 6.39922V26.5992C1.20001 29.3992 3.60001 31.7992 6.40001 31.7992H18C19.6 35.5992 23.6 38.3992 28 38.3992C32.4 38.3992 39 33.3992 39 27.3992C39 21.3992 34.8 17.1992 29.6 16.5992V16.3992ZM28 18.7992C32.8 18.7992 36.6 22.5992 36.6 27.3992C36.6 32.1992 32.8 35.9992 28 35.9992C23.2 35.9992 19.4 32.1992 19.4 27.3992C19.4 22.5992 23.2 18.7992 28 18.7992ZM6.40001 28.9992C5.00001 28.9992 3.80001 27.7992 3.80001 26.3992V6.39922C3.80001 4.99922 5.00001 3.79922 6.40001 3.79922H24.4C25.8 3.79922 27 4.99922 27 6.39922V16.3992C21.4 16.9992 17.2 21.5992 17.2 27.3992C17.2 33.1992 17.2 28.5992 17.2 29.1992H6.40001V28.9992Z'
        fill='currentColor'
      />
      <path
        d='M28 32.9996C28.6 32.9996 29.2 32.3996 29.2 31.7996V25.7996C29.2 25.1996 28.6 24.5996 28 24.5996C27.4 24.5996 26.8 25.1996 26.8 25.7996V31.7996C26.8 32.3996 27.4 32.9996 28 32.9996Z'
        fill='currentColor'
      />
      <path
        d='M28 23.9996C28.6627 23.9996 29.2 23.4623 29.2 22.7996C29.2 22.1369 28.6627 21.5996 28 21.5996C27.3372 21.5996 26.8 22.1369 26.8 22.7996C26.8 23.4623 27.3372 23.9996 28 23.9996Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_18420_5655'>
        <rect width={40} height={40} fill='currentColor' />
      </clipPath>
    </defs>
  </svg>
);
export default SvgGuideMd;
